/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import Feature from '@modules/utils/feature'

// eslint-disable-next-line import/no-restricted-paths
import { isFeatureActivated } from '@/store'

import type { CCMService } from './types'

export function isCCMFeatureActivated(): boolean {
  return isFeatureActivated(Feature.ccm)
}

export function isCCMAddNameFeatureActivated(): boolean {
  return isFeatureActivated(Feature.ccmAddName)
}

function isCCMEisFeatureActivated(): boolean {
  return isFeatureActivated(Feature.ccmEis)
}

export function getCCMServices(): readonly CCMService[] {
  const enabledServices: CCMService[] = ['auto_ops']

  if (isCCMEisFeatureActivated()) {
    enabledServices.push('eis')
  }

  return enabledServices
}
